import { z } from 'zod';

/**
 * 워커 트랜잭션의 1분 집계 (2026-09-07 결정 1).
 *
 * 대상 앱의 워커 넷은 `setInterval` + `OnModuleInit`이라 HTTP 진입이 없다. 계측이 http·express·
 * nest·pg·undici 다섯뿐이라 `tick()`에는 root span이 없고, 그 안에서 도는 SQL span이 부모 없이
 * 올라와 각각 하나의 `worker` 트랜잭션이 된다. OutboxWorker는 3초 주기라 하루에 3만 건 가까이
 * 쌓이는데, 개별 행으로 남겨 봐야 사람이 볼 것이 없고 저장만 커진다.
 *
 * 그래서 서버가 **진입점별 1분 버킷**으로 접고 개별 요약 행은 저장하지 않는다. 에이전트는
 * 손대지 않는다(규칙 3: 전송선은 OTLP 표준 그대로). 개별 span 저장 여부는 지금까지처럼
 * `APM_SPAN_SKIP_ENTRIES`가 정한다.
 *
 * 한 버킷은 `bucketStart`·`service`·`instance`·`entry` 넷으로 유일하다.
 */
export const WorkerAggregate = z.object({
  /** 1분 버킷의 시작 시각(epoch ms, 분 단위로 내림) */
  bucketStart: z.number().int().nonnegative(),
  /** OTel service.name */
  service: z.string().min(1),
  /** OTel service.instance.id. 없는 배포도 있어 선택이다 */
  instance: z.string().optional(),
  /** 진입점. 워커 이름 또는 root span 이름 */
  entry: z.string().min(1),
  /** 이 버킷에 접힌 트랜잭션 수 */
  count: z.number().int().positive(),
  /** 소요 시간 합계(ms) */
  totalMs: z.number().nonnegative(),
  /** 가장 오래 걸린 한 건(ms) */
  maxMs: z.number().nonnegative(),
  /** 상태가 error였던 건수 */
  errorCount: z.number().int().nonnegative(),
  /** 이 버킷의 트랜잭션들이 돌린 SQL 건수 합계 */
  sqlCount: z.number().int().nonnegative(),
});
export type WorkerAggregate = z.infer<typeof WorkerAggregate>;
